import { VirtualRoom } from './scene.js';
import { PlayerManager } from './player.js';
import { discordManager } from './discord.js';

class App {
  constructor() {
    this.room = null;
    this.playerManager = null;
    this.currentUser = null;
    this.isInitialized = false;
  }

  async init() {
    try {
      console.log('Iniciando aplicação...');
      
      // Inicializa o Discord
      this.currentUser = await discordManager.initialize();
      console.log('Discord inicializado:', this.currentUser.user.username);

      // Cria a sala virtual
      const container = document.getElementById('canvas-container');
      this.room = new VirtualRoom(container);
      console.log('Sala virtual criada');

      // Cria o gerenciador de jogadores
      this.playerManager = new PlayerManager(this.room);
      console.log('Gerenciador de jogadores criado');

      // Conecta o loop de atualização
      this.room.onUpdate = (deltaTime) => {
        this.playerManager.update(deltaTime);
      };

      // Configura callback para atualização de participantes
      discordManager.onParticipantsUpdate = (participants) => {
        this.onParticipantsUpdate(participants);
      };

      // Configura callback para atualização de posições
      discordManager.onPlayerPositionUpdate = (playerId, position) => {
        this.onPlayerPositionUpdate(playerId, position);
      };

      // Adiciona participantes iniciais
      const participants = discordManager.getParticipants();
      this.onParticipantsUpdate(participants);

      // Remove tela de carregamento
      this.hideLoading();

      // Atualiza interface
      this.updateUI();

      this.isInitialized = true;
      console.log('Aplicação inicializada com sucesso!');
    } catch (error) {
      console.error('Erro ao inicializar aplicação:', error);
      this.showError('Erro ao inicializar a aplicação. Verifique o console.');
    }
  }

  onParticipantsUpdate(participants) {
    console.log('Atualizando participantes:', participants.length);

    // Remove jogadores que saíram
    const participantIds = new Set(participants.map(p => p.id));
    const currentPlayerIds = new Set(this.playerManager.players.keys());

    currentPlayerIds.forEach(playerId => {
      if (!participantIds.has(playerId)) {
        this.playerManager.removePlayer(playerId);
      }
    });

    // Adiciona novos jogadores
    participants.forEach(participant => {
      if (!this.playerManager.getPlayer(participant.id)) {
        const isLocal = participant.id === this.currentUser.user.id;
        this.playerManager.addPlayer(participant.id, participant.username, isLocal);
      }
    });

    // Inicia loop de sincronização se ainda não estiver rodando
    if (!this.syncInterval) {
      this.startSyncLoop();
    }

    this.updateUI();
  }

  onPlayerPositionUpdate(playerId, position) {
    // Atualiza a posição do jogador remoto
    this.playerManager.updatePlayerPosition(playerId, position.x, position.y, position.z);
  }

  startSyncLoop() {
    // Envia a posição do jogador local periodicamente
    this.syncInterval = setInterval(() => {
      const position = this.playerManager.getLocalPlayerPosition();
      if (position) {
        discordManager.sendPlayerPosition(position);
      }
    }, 50); // Envia atualizações a cada 50ms
  }

  updateUI() {
    const userCountEl = document.getElementById('user-count');
    const userIdEl = document.getElementById('user-id');

    if (userCountEl) {
      userCountEl.textContent = this.playerManager.getPlayerCount();
    }

    if (userIdEl && this.currentUser) {
      userIdEl.textContent = this.currentUser.user.username;
    }
  }

  hideLoading() {
    const loadingEl = document.getElementById('loading');
    const infoEl = document.getElementById('info');

    if (loadingEl) {
      loadingEl.classList.add('hidden');
    }

    if (infoEl) {
      infoEl.classList.remove('hidden');
    }
  }

  showError(message) {
    const loadingEl = document.getElementById('loading');
    if (loadingEl) {
      loadingEl.innerHTML = `
        <div style="color: #ff4444;">
          <div>❌ Erro</div>
          <div style="font-size: 16px; margin-top: 10px;">${message}</div>
        </div>
      `;
    }
  }
}

// Inicializa a aplicação quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  const app = new App();
  app.init();
});
